import { linkpickTheme, switchThemeComponent } from '@webapps/styles';

const { params: prismeParams } = linkpickTheme;

const {
  colors: { black2, grey4, grey5, grey6, grey7, white },
} = prismeParams;

const defaultTheme = {
  colors: {
    borderColor: grey5,
    tableCellColor: grey6,
    tableCellHeadColor: black2,
    tableCellHeadColorHover: grey6,
    cellSubTextColor: grey4,
    tableRowBackgroundHoverColor: white,
    tableRowOddBackgroundColor: white,
    cellTitleTextColor: grey6,
  },
};

export default switchThemeComponent({
  default: defaultTheme,
});
